import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import { TPoolTable } from "../../Types";

export const apiCallCleanAdminPool = async (
  adminId: number,
  poolType: TPoolTable
): Promise<{
  data: string;
  status: string;
  code: Ti18nKeys;
}> => {
  const pageName = getCoreHistoryStore().pageName.get();

  const { status, data, et3Error } = await post("core/cleanAdminPoolByType", {
    adminId,
    pageName,
    poolType
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
